import {createRouter, createWebHistory} from 'vue-router'
import CheckComponent from "@/views/Check-Component.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import LoginComponent from "@/views/Login-Component.vue";
import EvidenciaComponent from "@/views/Evidencia-Component.vue";
import PerfilComponent from '@/views/Perfil-Component.vue';
import HomeView from "@/views/HomeView.vue";
import { inject } from 'vue'

function guard(permiso, next) {
  const storage = inject('$localStorageService')
  try {
    if (storage.isAuth()) {
      if (permiso == null || storage.can(permiso)) {
        next();
      } else {
        next({
          name: "home"
        });
      }
    } else {
      console.info("NO LOGEADO")
      next({
        name: "login"
      });
    }
  } catch (e) {
    console.info(e);
    next({
      name: "login"
    });
  }
}

const routes = [
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
  { path: '/', component: LoginComponent, name: 'inicio' },
  { path: '/login', component: LoginComponent, name: 'login' },


  { path: '/registrarEvento', component: CheckComponent, name: 'registrarEvento',
    beforeEnter: (to, from, next) => {
      guard('api.REGISTRO_ASISTENCIA', next);
    }
  },

  { path: '/registrarEvidencia', component: EvidenciaComponent, name: 'registrarEvidencia' ,
    beforeEnter: (to, from, next) => {
      guard('api.TOMAR_EVICENCIA', next);
    }
  },

  { path: '/inicio', component: PerfilComponent, name: 'perfil' ,
    beforeEnter: (to, from, next) => {
      guard(null, next);
    }
  },

  { path: '/home', component: HomeView, name: 'home',
    beforeEnter: (to, from, next) => {
      guard(null, next);
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
